import { Title } from '@mantine/core';

import { SimpleLayout, type SimpleLayoutProps } from './simple';

type Props = SimpleLayoutProps & {
	title: string;
};

export function TitleLayout({ title, children, ...props }: Props) {
	return (
		<SimpleLayout {...props}>
			<Title order={1}>{title}</Title>
			{children}
		</SimpleLayout>
	);
}
